import { useCallback } from 'react';

import {
  CategoryID,
  CategoryLocalizedName
} from '../../../../../../../../categories/categoriesTypes';
import { ButtonHelper } from '../../../../../../../../../helpers/buttons/ButtonHelper';

interface ThreeDStockProductsFiltersRenderTypeFilterItemCategory {
  id: CategoryID;
  localizedName: CategoryLocalizedName;
}

interface ThreeDStockProductsFiltersRenderTypeFilterItemProps {
  category: ThreeDStockProductsFiltersRenderTypeFilterItemCategory;
  onCheckedCategory: (categoryId: CategoryID, checked: boolean) => void;
  checked: boolean;
}

function ThreeDStockProductsFiltersRenderTypeFilterItem({
  onCheckedCategory,
  category,
  checked
}: ThreeDStockProductsFiltersRenderTypeFilterItemProps) {
  const handleCheck = useCallback(() => {
    onCheckedCategory(category.id, !checked);
  }, [onCheckedCategory, category, checked]);

  return (
    <ButtonHelper
      key={category.id}
      className={
        checked
          ? 'border rounded text-sm flex items-center h-8 box-content border-blue-200 dark:border-transparent bg-blue-100 hover:bg-blue-50 text-black'
          : 'border rounded text-sm flex items-center h-8 box-content border-gray-300 dark:border-gray-700 hover:bg-gray-500/10 text-gray-700 dark:text-gray-300'
      }
      dataGa={`category-${category.id}`}
      onClick={handleCheck}
    >
      <span className="px-3 whitespace-nowrap">{category.localizedName}</span>
    </ButtonHelper>
  );
}

export default ThreeDStockProductsFiltersRenderTypeFilterItem;
